import React from 'react';
import type { IERPUser } from '@admin-panel/types';
import { VendorSelector } from '../../header';
import SettingsSection from './SettingsSection';

type Props = {
  user?: IERPUser;
};

const VendorGeneralSettings: React.FC<Props> = ({ user }) => (
  <SettingsSection
    title="Vendor context"
    description="Select the vendor and facility you want to manage."
  >
    <VendorSelector user={user} />
  </SettingsSection>
);

export default VendorGeneralSettings;
